module.exports = __webpack_public_path__ + "language-switcher-01ac634c/illustration-left-c2d02721bd993962fb56c956203e11de.svg";